<template>
  <div>
    <QueryFrame
      :count="count"
      :current="page"
      :add-text="handlePermission('curingRuleAdd')?'创建养护规则':''"
      @handlePage="handlePage"
      @handlePageSize="handlePageSize"
      @addNew="addNew">
      <div slot="queryParams">
        <div class="queryContainer">
          <div class="queryItem" v-if="roleType!==2">
            <label>门店名称:</label>
            <storeListSelect class="item" v-model="query.storeIdList"></storeListSelect>
          </div>
          <div class="queryItem">
            <label>养护规则名称:</label>
            <lk-input class="item" :maxlength="100" placeholder="请输入" clearable v-model.trim="query.name"></lk-input>
          </div>
          <div class="queryItem">
            <label>养护标准:</label>
            <lk-select class="item" v-model="query.standard" clearable placeholder="请选择">
              <lk-option v-for="item in standardMap" :value="item[0]" :key="item[0]">
                {{ item[1] }}
              </lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>状态:</label>
            <lk-select class="item" v-model="query.status" clearable>
              <lk-option v-for="item in statusMap" :value="item[0]" :key="item[0]">
                {{ item[1] }}
              </lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <lk-button class="mr" type="primary" @click="handleSearch">查询</lk-button>
            <lk-button @click="handleReset">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <lk-table border :columns="columns" :data="tableData"></lk-table>
      </div>
    </QueryFrame>
  </div>
</template>

<script>
import QueryFrame from '../../components/frame/QueryFrame.vue';
import utils from '../../libs/utils';
import inventory from '../../services/inventory';
import mapState from '../../mixins/mapState';
import queryMixins from '../../mixins/queryMixins';

export default {
  name: 'curingRuleList',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame,
  },
  data() {
    return {
      standardMap: new Map([
        [1, '一般养护'],
        [2, '重点养护'],
      ]),
      statusMap: new Map([
        [1, '启用'],
        [2, '禁用'],
      ]),
      priorityMap: new Map([
        [1, '低'],
        [2, '中'],
        [3, '高'],
      ]),
      query: {
        storeIdList: [],
        name: null,
        standard: null,
        status: null,
      },
      columns: [
        {
          title: '序号',
          type: 'index',
          minWidth: 80,
          indexMethod: row => (row._index + this.size * (this.page - 1)) + 1,
        },
        {
          title: '养护规则名称',
          key: 'curingRuleName',
          minWidth: 116,
        },
        {
          title: '养护标准',
          key: 'curingRuleStandardStr',
          minWidth: 116,
        },
        {
          title: '养护周期',
          key: 'curingRuleCycleStr',
          minWidth: 116,
        },
        {
          title: '养护范围',
          key: 'curingRuleWarehouseNames',
          minWidth: 116,
        },
        {
          title: '养护提醒',
          key: 'curingRuleAlertDaysStr',
          minWidth: 116,
        },
        {
          title: '优先级',
          key: 'curingRulePriorityStr',
          minWidth: 116,
        },
        {
          title: '开始时间',
          key: 'curingRuleStartTimeStr',
          minWidth: 116,
        },
        {
          title: '结束时间',
          key: 'curingRuleEndTimeStr',
          minWidth: 116,
        },
        {
          title: '状态',
          key: 'curingRuleStatusStr',
          fixed: 'right',
          minWidth: 116,
        },
        {
          title: '操作',
          key: 'action',
          fixed: 'right',
          width: 130,
          render: (h, { row }) => h('div', {
            class: {
              textCenter: true,
            },
          },
          [
            this.handlePermission('curingRuleView') ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
                disabled: !row.curingRuleId,
              },
              on: {
                click: () => {
                  this.$router.push({
                    name: 'curingRuleView',
                    params: { id: row.curingRuleId },
                  });
                },
              },
            }, '查看') : null,
            this.handlePermission('curingRuleEdit') ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.$router.push({
                    name: 'curingRuleEdit',
                    params: { id: row.curingRuleId },
                  });
                },
              },
            }, '编辑') : null,
          ]),
        },
      ],
      tableData: [],
    };
  },
  methods: {
    getData() {
      this.params.page = this.page;
      this.params.size = this.size;
      inventory.curingRuleList(this.params).then((res) => {
        if (res.data.status === 200) {
          this.tableData = [];
          const { count, list } = res.data.data;
          this.count = count;
          list.forEach((item) => {
            const result = {};
            utils.exchangeTable(item, result);
            result.curingRuleStandardStr = this.standardMap.get(result.curingRuleStandard);
            result.curingRuleCycleStr = `${result.curingRuleCycle}天`;
            result.curingRuleAlertDaysStr = `${result.curingRuleAlertDays}天`;
            result.curingRulePriorityStr = this.priorityMap.get(result.curingRulePriority) || '-';
            result.curingRuleStartTimeStr = utils.formatDate(result.curingRuleStartTime) || '-';
            result.curingRuleEndTimeStr = utils.formatDate(result.curingRuleEndTime) || '-';
            result.curingRuleStatusStr = this.statusMap.get(result.curingRuleStatus);
            if (result.curingRuleDefaultFlag === 2) {
              const tempRang = [];
              if (result.curingRuleContainExpiry === 1) {
                tempRang.push('近效期商品');
              }
              if (result.curingRuleContainExpensive === 1) {
                tempRang.push('性状不稳定、贵细商品');
              }
              result.curingRuleWarehouseNames = tempRang.join(',');
            }
            this.tableData.push(result);
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    addNew() {
      this.$router.push({ name: 'curingRuleAdd' });
    },
    handleReset() {
      this.query = {};
    },
  },
  created() {
    this.handleSearch(true);

    if (this.roleType !== 2) {
      this.columns.splice(1, 0, {
        title: '门店名称',
        key: 'storeName',
        minWidth: 116,
      });
    }
  },
};
</script>
<style lang="less" scoped>
</style>
